import { render, staticRenderFns } from "./MakerCourseManageView.vue?vue&type=template&id=b884994c&scoped=true"
import script from "./MakerCourseManageView.vue?vue&type=script&lang=js"
export * from "./MakerCourseManageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b884994c",
  null
  
)

export default component.exports